import {Component, OnInit} from '@angular/core';
import {UtilService} from "../../../../services/util.service";
import {TableColumn} from "../../../../dto/util/table-column";
import {InfoPantallaDTO} from "../../../../dto/util/infoPantallaDTO";
import {ActivatedRoute, Router} from "@angular/router";
import {ExpedienteService} from "../../../../services/expediente.service";
import {TranslateService} from "@ngx-translate/core";
import {TableAction} from "../../../../dto/util/table-action";
import {ExpedienteSSIDTO} from "../models/expedienteSSIDTO";
import {Constants} from "../../../../constants/constants";
import {EntidadApiResponse} from "../../../../dto/entidad/entidad-response.dto";
import {EntidadService} from "../../../../services/entidad.service";

@Component({
  selector: 'app-detalle-proceso-insolvencia',
  templateUrl: './detalle-proceso-insolvencia.component.html',
  styleUrl: './detalle-proceso-insolvencia.component.scss'
})
export class DetalleProcesoInsolvenciaComponent implements OnInit {
  // Tabla
  columnas: TableColumn[] = [];
  acciones: TableAction[] = [];
  // Multilenguaje
  insolvenciaText: any = {};
  guiaText: any = {};
  guiaInsolvenciaText: any = {};
  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;
  // Number
  idExpediente = 0;
  usuarioCreadorId = 0;
  entidadId = Constants.ID_ENTIDAD_SUPER_SOCIEDADES;
  // Boolean
  mostrarArchivos = false;
  showButton = true;
  isCreator = false;
  // Datos de las tablas
  datosExpedienteSSI: ExpedienteSSIDTO[] = [];
  // String
  role = '';
  // Entidad
  entidad!: EntidadApiResponse;
  constructor(
    private translate: TranslateService,
    private utilService: UtilService,
    private expedienteService: ExpedienteService,
    private route: ActivatedRoute,
    private router: Router,
    private entidadService: EntidadService
  ) {
    // Multilenguaje
    this.translate.stream('guias-interactivas').subscribe(text => {
      this.guiaText = text;
      this.ngOnInit();
    });
    this.translate.stream('guia-supersociedades-insolvencia').subscribe(text => {
      this.guiaInsolvenciaText = text;
      this.ngOnInit();
    });
    // Se captura de la url, el ID del expediente
    this.route.params.subscribe(params => {
      this.idExpediente = params['expedienteId'];
      this.usuarioCreadorId = params['usuarioId'];
    });
    const userData = sessionStorage.getItem(Constants.USER_TYPE);
    if (userData) {
      const parseObject = JSON.parse(userData);
      this.role = parseObject.Nombre;
    }
  }
  ngOnInit(): void {
    // Se inicializan las columnas de la tabla
    this.initColumns();
    // Entidad
    this.cargarEntidad();
    // Multilenguaje
    this.translate.stream('supersociedades-insolvencia').subscribe(text => {
      this.insolvenciaText = text;
      this.initColumns();
    });
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: this.guiaInsolvenciaText['titulo'],
      descripcionPantalla: '',
      pasos: [
        {
          element: '#navbarDropdownDetalle',
          popover: {
            title: this.guiaText['usuario-titulo'],
            description: this.guiaText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#dropdownAlertasButton',
          popover: {
            title: this.guiaText['alertas-titulo'],
            description: this.guiaText['alertas-descripcion'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#glosario',
          popover: {
            title: this.guiaText['glosario-titulo'],
            description: this.guiaText['glosario-descripcion'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#informacion',
          popover: {
            title: this.guiaText['info-titulo'],
            description: this.guiaText['info-descripcion'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#id',
          popover: {
            title: 'ID',
            description: this.guiaInsolvenciaText['ID'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#radicado',
          popover: {
            title: this.insolvenciaText['numero-radicado'],
            description: this.guiaInsolvenciaText['radicado'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#fechaCarga',
          popover: {
            title: this.insolvenciaText['fecha-carga'],
            description: this.guiaInsolvenciaText['fecha-carga'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#fechaRadicacion',
          popover: {
            title: this.insolvenciaText['fecha-radicacion'],
            description: this.guiaInsolvenciaText['fecha-radicacion'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#estado',
          popover: {
            title: this.insolvenciaText['estado'],
            description: this.guiaInsolvenciaText['estado'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#usuario',
          popover: {
            title: this.insolvenciaText['usuario-solicitante'],
            description: this.guiaInsolvenciaText['usuario'],
            side: 'bottom',
            align: 'start',
          }
        }
      ]
    }
    // Se obtiene los datos de sesión del usuario
    const dataUsuario = JSON.parse(
      sessionStorage.getItem('user_information_session')!
    );
    // Se valida que sea el primer inicio de sesión para ejecutar la guía interactiva
    if (dataUsuario.primerInicioSesion) {
      this.utilService.changeInfoPantalla(this.infoPantalla);
      this.utilService.iniciarGuiaInteractiva();
    } else {
      this.utilService.changeInfoPantalla(this.infoPantalla);
    }
    // Se lista expediente SSI
    this.listarExpediente();
    this.isCreator = dataUsuario.idUsuario === +this.usuarioCreadorId;
    this.utilService.watch().subscribe(val => {
      this.showButton = val;
    });
    this.utilService.setIdEntidad(this.entidadId);
  }

  // Columnas de la tabla
  initColumns() {
    this.columnas = [
      {
        id: 'id',
        field: 'id',
        title: 'ID',
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'radicado',
        field: 'numeroRadicado',
        title: this.insolvenciaText['numero-radicado'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'fechaCarga',
        field: 'fechaCargaInformacion',
        title: this.insolvenciaText['fecha-carga'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '200px'
      },
      {
        id: 'fechaRadicacion',
        field: 'fechaRadicacion',
        title: this.insolvenciaText['fecha-radicacion'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'estado',
        field: 'estado',
        title: this.insolvenciaText['estado'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'usuario',
        field: 'usuarioSolicitante',
        title: this.insolvenciaText['usuario-solicitante'],
        type: 'text',
        filterable: false,
        sortable: false,
      }
    ]
    // Columna de acciones
    this.acciones = [
      {
        type: 'button',
        icon: 'file',
        title: this.insolvenciaText['adjuntos'],
        idAccion: '1',
      }
    ];
  }

  // Se consume el servicio de listar expediente SSI
  listarExpediente() {
    this.expedienteService.expedienteSSI(this.idExpediente).subscribe((resp: ExpedienteSSIDTO[]) => {
      this.datosExpedienteSSI = resp;
      this.datosExpedienteSSI = this.datosExpedienteSSI.map((item: ExpedienteSSIDTO) => {
        item.fechaCargaInformacion = new Date(item.fechaCargaInformacion).toLocaleDateString();
        item.fechaRadicacion = new Date(item.fechaRadicacion).toLocaleDateString();
        return item;
      });
    });
  }
  // Se validan las acciones de la tabla principal de histórico
  accionesExpedienteSSI(elemento: any) {
    // Si la acción es ver adjuntos, se muestra el componente de archivos
    if (elemento.idAccion === '1') {
      this.mostrarArchivos = true;
    }
  }
  crearAvanceProcesal() {
    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.idExpediente}`,
    ]);
  }

  navigateAvanceProcesalSolicitudes() {
    if (this.showButton) {
      this.utilService.show();
    } else {
      this.utilService.hide();
    }

    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.idExpediente}/solicitudes`,
    ]);
  }

  cargarEntidad(): void {
    this.entidadService.obtenerEntidadPorId(this.entidadId).subscribe({
      next: (data) => {
        this.entidad = data;
      },
      error: (error) => console.error('Error al obtener la entidad:', error),
    });
  }
}
